import { useCallback, useEffect, useState } from 'react';
import { shortAddress } from '../../utils/connectionConfig';
import {
  apiErrorMessage,
  fetchNativeUsdBalance,
  fetchTokenBalance,
} from '../../utils/api';
import ConnectButton from '../connect/ConnectButton';
import {
  stakingAddress,
  admins,
  mainAdmin,
  claimAdmin,
} from '../../config/config';
import './HeaderComp.css';

const withSpaces = (value) =>
  String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

const HeaderComp = ({ refreshKey }) => {
  const [emivnBalance, setEmivnBalance] = useState('Загрузка...');
  const [mainAdminUsdBalance, setMainAdminUsdBalance] = useState('Загрузка...');
  const [claimAdminUsdBalance, setClaimAdminUsdBalance] =
    useState('Загрузка...');

  const fetchBalances = useCallback(async () => {
    const loadEmivnBalance = async () => {
      try {
        setEmivnBalance(
          withSpaces(Math.floor(await fetchTokenBalance(stakingAddress))),
        );
      } catch (error) {
        console.error('Error fetching token balance:', error);
        setEmivnBalance('Ошибка');
      }
    };

    const loadUsdBalance = async (address, setBalance) => {
      try {
        setBalance((await fetchNativeUsdBalance(address)).toFixed(2));
      } catch (error) {
        console.error(
          `Error fetching wallet balance ${address}:`,
          apiErrorMessage(error),
        );
        setBalance('Ошибка');
      }
    };

    await Promise.all([
      loadEmivnBalance(),
      loadUsdBalance(mainAdmin, setMainAdminUsdBalance),
      loadUsdBalance(claimAdmin, setClaimAdminUsdBalance),
    ]);
  }, []);

  // refreshKey меняется после успешного стейкинга: баланс контракта при этом
  // вырос, и показывать прежнее число нельзя. Раньше это скрывала полная
  // перезагрузка страницы.
  useEffect(() => {
    fetchBalances();
  }, [fetchBalances, refreshKey]);

  return (
    <>
      <h1>Стейкинг проект EMIVN</h1>
      <header>
        <div className="header__left">
          <div className="header__admin-section">
            <div className="header__admin-title">Главный админ:</div>
            <div className="header__admin">{mainAdmin}</div>
          </div>
          <div className="header__admins">
            <div className="header__admin-title">Админы:</div>
            {admins.map((admin, index) => (
              <span key={index}>{admin}</span>
            ))}
          </div>
          <div className="header__admin-section">
            <div className="header__admin-title">
              <span style={{ color: 'red' }}>Claim</span> кошелек:
            </div>
            <div className="header__admin">{claimAdmin}</div>
          </div>
        </div>

        <div className="header__right">
          <div className="header__info">
            Баланс токенов на{' '}
            <a
              href={`https://bscscan.com/address/${stakingAddress}`}
              target="_blank"
              rel="noreferrer"
            >
              контракте
            </a>
            : <strong>{emivnBalance}</strong> EMIVN
          </div>
          <div className="header__info">
            Баланс кошелька{' '}
            <a
              href={`https://bscscan.com/address/${mainAdmin}`}
              target="_blank"
              rel="noreferrer"
            >
              {shortAddress(mainAdmin)}
            </a>
            : <strong>{mainAdminUsdBalance}</strong> USD
          </div>
          <div className="header__info">
            Баланс <span style={{ color: 'red' }}>claim</span> кошелька{' '}
            <a
              href={`https://bscscan.com/address/${claimAdmin}`}
              target="_blank"
              rel="noreferrer"
            >
              {shortAddress(claimAdmin)}{' '}
            </a>
            : <strong>{claimAdminUsdBalance}</strong> USD
          </div>
          <div className="header__buttons">
            <ConnectButton />
          </div>
        </div>
      </header>
    </>
  );
};

export default HeaderComp;
